import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';

@model.cacheDuration()
@model.urnResource('client_request_type')
@doc.path('/client_request_types/{?id}')
export default class ClientRequestTypeModel extends AccountServiceModel {
	private declare _tsSorts: {
		'id': string;
		'label': string;
	};

	@doc.string declare label: string;
	@doc.string declare name: Account_ClientRequestTypeName;

	public get isGdpr(): boolean {
		return this.name === 'GDPR';
	}

	public get color(): string | undefined {
		switch (this.name) {
			case 'INFORMATION':
				return 'cyan';
			case 'SUPPORT':
				return 'purple';
			default:
				return undefined;
		}
	}
}
